
export default class ProjectInstallationType {

    static ETABLERINGSPROJEKT = "1"
    static SKABSPROJEKT = "Skabsprojekt"
    static INSTALLATIONSPROJEKT = "Installationsprojekt"
    static EFTERTILSLUTNING = "Eftertilslutning"
    static KONVERTERING = "Konvertering"
    static INSTALLATIONSPROJEKTOPSAMLING = "Installationsprojekt (Opsamling)"
    static TICKET = "TroubleTickets"

    // static INSTALLATION = 'installations'
    // static LATE_SIGNUP = 'late_signup'

}
